var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#212933",
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pagination/Default",
    transform: "translate(-12.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22,12.72 C8.07930751,12.5794826 8.00017505,12.3888454 8,12.19 L8,11.81 C8.00230401,11.6115859 8.08111602,11.4217206 8.22,11.28 L13.36,6.15 C13.4538833,6.05534367 13.5816812,6.00210084 13.715,6.00210084 C13.8483188,6.00210084 13.9761167,6.05534367 14.07,6.15 L14.78,6.86 C14.8740641,6.95216359 14.9270714,7.07831031 14.9270714,7.21 C14.9270714,7.34168969 14.8740641,7.46783641 14.78,7.56 L10.33,12 L14.78,16.44 C14.8746563,16.5338833 14.9278992,16.6616812 14.9278992,16.795 C14.9278992,16.9283188 14.8746563,17.0561167 14.78,17.15 L14.07,17.85 C13.9761167,17.9446563 13.8483188,17.9978992 13.715,17.9978992 C13.5816812,17.9978992 13.4538833,17.9446563 13.36,17.85 L8.22,12.72 Z",
    id: "icon"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.896fcb9e2710581ecfe8c9d4397e6371.svg";
export { ForwardRef as ReactComponent };